'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGE_SEPARATOR = '..';

function template() {
    var _this = this;

    var classList = this.compileStyle(_index2.default),
        increment = null,
        decrement = null,
        pageList = this._getPagesRow(),
        content = [],
        page = this.props.page instanceof Array ? this.props.page : [this.props.page];

    if (this.props.incrementButton) {
        increment = _react2.default.createElement(
            _Button2.default,
            {
                onClick: this.toNext.bind(this),
                disabled: this.isPageSelected(this.props.totalPages),
                className: classList.incrementButton,
                square: true
            },
            _react2.default.createElement('div', { className: classList.increment })
        );
    }

    if (this.props.decrementButton) {
        decrement = _react2.default.createElement(
            _Button2.default,
            {
                onClick: this.toPrev.bind(this),
                disabled: this.isPageSelected(1),
                className: classList.decrementButton,
                square: true
            },
            _react2.default.createElement('div', { className: classList.decrement })
        );
    }

    pageList.forEach(function (item, i) {
        var selectedIndex = page.indexOf(item),
            next = pageList[i + 1],
            className = classList.page;

        if (selectedIndex >= 0) {
            if (page.length === 1) {
                className = classList.pageSelectedSingle;
            } else if (selectedIndex === 0) {
                className = classList.pageSelectedStart;
            } else if (selectedIndex === page.length - 1) {
                className = classList.pageSelectedEnd;
            } else {
                className = classList.pageSelected;
            }

            content.push(_react2.default.createElement(
                'div',
                { key: item, className: className, onClick: function onClick(e) {
                        return _this.toPage(item);
                    } },
                _react2.default.createElement(
                    'div',
                    { className: classList.pageWrapperSelected },
                    item
                )
            ));

            if (next && item + 1 < next) {
                content.push(_react2.default.createElement(
                    'div',
                    { key: item + 1, className: classList.separatorSelected },
                    PAGE_SEPARATOR
                ));
            }
        } else {
            content.push(_react2.default.createElement(
                'div',
                { key: item, className: className, onClick: function onClick(e) {
                        return _this.toPage(item);
                    } },
                _react2.default.createElement(
                    'div',
                    { className: classList.pageWrapper },
                    item
                )
            ));

            if (next && item + 1 < next) {
                content.push(_react2.default.createElement(
                    'div',
                    { key: item + 1, className: classList.separator },
                    PAGE_SEPARATOR
                ));
            }
        }
    });

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        decrement,
        content,
        increment
    );
}